import { useEffect, useRef, useState } from "react";
import { Stack, Typography } from "@mui/material";
import { subtypes } from "../../../../types/actionModule/actionModuleTypes";
import { SubtypeDefinition } from "../../../../types/actionModule/actionModule";
import { draggable } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import { getNewSubtypeDragData } from "./dragAndDropHelpers";
import { useTranslation } from "react-i18next";

export default function SubtypeToolbox() {
    return <div style={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        overflow: "auto",
        paddingRight: "10px"
    }}>
        {subtypes.map(p => <SubtypeToolboxEntry key={p.name} subtype={p} />)}
    </div>
}

interface SubtypeToolboxEntryProps {
    subtype: SubtypeDefinition;
}

function SubtypeToolboxEntry(props: SubtypeToolboxEntryProps) {
    const ref = useRef(null);
    const [isDragging, setIsDragging] = useState(false);

    useEffect(() => {
        const el = ref.current!;

        const data = getNewSubtypeDragData({
            subtype: props.subtype,
        });

        return draggable({
            element: el,
            getInitialData: () => data,
            onDragStart: () => setIsDragging(true),
            onDrop: () => setIsDragging(false),
        });
    }, []);

    return <div
        style={{
            padding: "10px",
            minHeight: "50px",
            borderRadius: "4px",
            borderStyle: "solid",
            borderWidth: 1,
            borderColor: "#e0e0e0",
            background: "white",
            userSelect: "none",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            opacity: isDragging ? 0.5 : 1
        }}
        ref={ref}>
        {props.subtype.toolboxPlaceholder()}
    </div>
}

interface SubtypeToolboxPlaceholderScaffoldProps {
    icon: React.ReactElement;
    name: string;
}

export function SubtypeToolboxPlaceholderScaffold(props: SubtypeToolboxPlaceholderScaffoldProps) {
    const { t } = useTranslation();

    return <Stack direction="row" sx={{ alignItems: "center", gap: 2 }}>
        {props.icon}
        <Typography variant="body1">{t(props.name)}</Typography>
    </Stack>
}